module.exports = __webpack_public_path__ + "1f96733a361be9e388c527ba3aa406ce.pdf";